import {Body} from 'shells/typography/body';

import {DataFieldWrapper} from '../../../core-entity/widgets/summary-widget/data-field-wrapper';

type Props = {
    territory: string;
};

export function LeadTerritory(props: Props) {
    return <DataFieldWrapper label='Territory' children={<Body>{props.territory}</Body>} />;
}
